export default __webpack_public_path__ + "static/media/badge-dollar.6f6ac623.svg";